import { PumpEntity, PumpFilter } from '../../models'

export const SET_PUMPS = 'SET_PUMPS'
export const SET_PUMPS_LOADED = 'SET_PUMPS_LOADED'
export const SET_PUMP_FILTER = 'SET_PUMP_FILTER'
export const SET_SELECTED_PUMP = 'SET_SELECTED_PUMP'

export interface PumpState {
  pumps: PumpEntity[]
  isPumpsLoaded: boolean
  pumpFilter: PumpFilter
  selectedPump?: PumpEntity
}

interface SetPumpFilterAction {
  type: typeof SET_PUMP_FILTER
  payload: PumpFilter
}

interface SetSelectedPumpAction {
  type: typeof SET_SELECTED_PUMP
  payload?: PumpEntity
}

interface SetPumpsAction {
  type: typeof SET_PUMPS
  payload: PumpEntity[]
}

interface SetPumpsLoadedAction {
  type: typeof SET_PUMPS_LOADED
  payload: boolean
}

export type PumpAction =
  | SetPumpFilterAction
  | SetSelectedPumpAction
  | SetPumpsAction
  | SetPumpsLoadedAction
